import React, { useEffect, useState } from 'react';
import Dialogo from './Dialogo';

/**
 * `confirmar()` e `avisar()` — o substituto PROFISSIONAL de `window.confirm` e `window.alert`.
 *
 * Regra do Caique (03/11/2026): nada de modal nativo do navegador no admin. Estas duas funções
 * devolvem Promise e abrem o `Dialogo` do próprio app, então a troca numa tela é mecânica:
 *
 *     if (!window.confirm('Excluir?')) return;
 *     if (!(await confirmar({ titulo: 'Excluir termo', mensagem: 'Excluir?', perigo: true }))) return;
 *
 * `mensagem` é texto (quebras de linha respeitadas); `corpo` aceita JSX para prévias ricas
 * (listas de vendedores, números de impacto). O host é montado UMA vez no Shell do App.
 */
let abrir = null;

export function confirmar(opcoes = {}, extra = {}) {
    if (typeof opcoes === 'string') opcoes = { mensagem: opcoes, ...extra };
    return new Promise((resolve) => {
        if (!abrir) {
            // Host não montado é bug de montagem, não "cancelar": avisa no console para não
            // virar um botão que não faz nada em silêncio.
            console.error('ConfirmacaoHost não está montado — confirmar() não tem onde abrir.');
            resolve(false);
            return;
        }
        abrir({ ...opcoes, resolve });
    });
}

/** Aviso com um botão só (o `alert` do admin). Resolve quando a pessoa fecha. */
export function avisar(opcoes = {}, extra = {}) {
    const o = typeof opcoes === 'string' ? { mensagem: opcoes, ...extra } : opcoes;
    return confirmar({ titulo: 'Aviso', rotuloConfirmar: 'OK', ...o, soOk: true });
}

export function ConfirmacaoHost() {
    const [pedido, setPedido] = useState(null);
    useEffect(() => {
        abrir = setPedido;
        return () => { abrir = null; };
    }, []);
    if (!pedido) return null;
    const fechar = (valor) => {
        pedido.resolve(valor);
        setPedido(null);
    };
    return (
        <Dialogo
            titulo={pedido.titulo || 'Confirmar'}
            onCancelar={() => fechar(false)}
            onConfirmar={() => fechar(true)}
            rotuloConfirmar={pedido.rotuloConfirmar || 'Confirmar'}
            rotuloCancelar={pedido.rotuloCancelar || 'Cancelar'}
            semCancelar={!!pedido.soOk}
            perigo={!!pedido.perigo}
            largo={!!pedido.largo}
        >
            {pedido.corpo || <p className="dlg-texto">{pedido.mensagem}</p>}
        </Dialogo>
    );
}
